import { DropdownOptions } from "@trailhead/asurion-ui";

export type MobileDeviceValue =
  | "iPhone"
  | "Samsung (Android)"
  | "Pixel"
  | "Other Android";

export enum MobileDeviceLabels {
  iPhone = "iPhone",
  Samsung = "Samsung (Android)",
  Pixel = "Pixel",
  OtherAndroid = "Other Android",
}

export enum MobileDeviceValues {
  iPhone = "iPhone",
  Samsung = "Samsung (Android)",
  Pixel = "Pixel",
  OtherAndroid = "Other Android",
}

export interface DeviceList {
  newDeviceList: DropdownOptions[];
  oldDeviceList: DropdownOptions[];
}

export const FALLBACK_DEVICE_LIST: DeviceList = {
  newDeviceList: [
    {
      name: "iPhone",
      value: "iPhone",
    },
    {
      name: "Samsung (Android)",
      value: "Samsung (Android)",
    },
    {
      name: "Pixel",
      value: "Pixel",
    },
    {
      name: "Other Android",
      value: "Other Android",
    },
  ],
  oldDeviceList: [
    {
      name: "iPhone",
      value: "iPhone",
    },
    {
      name: "Samsung (Android)",
      value: "Samsung (Android)",
    },
    {
      name: "Pixel",
      value: "Pixel",
    },
    {
      name: "Other Android",
      value: "Other Android",
    },
  ],
};

export interface DeviceDropdownLabels {
  newDeviceDropdownLabel: string;
  oldDeviceDropdownLabel: string;
}

export const FALLBACK_DEVICE_DROPDOWN_LABELS: DeviceDropdownLabels = {
  newDeviceDropdownLabel: "What brand is your new device?",
  oldDeviceDropdownLabel: "What brand is your old device?"
}

export interface DeviceDropdownInputLabels {
  newDeviceInputLabel: string;
  oldDeviceInputLabel: string;
}

export const FALLBACK_DEVICE_DROPDOWN_INPUT_LABELS: DeviceDropdownInputLabels = {
  newDeviceInputLabel: "Choose your new device",
  oldDeviceInputLabel: "Choose your old device"
}

export interface QuestionLabels {
  replacementThroughClaim: string;
  newDeviceAlreadyActivated: string;
  oldDeviceAccess: string;
  oldDeviceFunctional: string;
  newDeviceIsNewiPhoneVersion: string;
  newDeviceIsiPhone14?: string;
}

export const FALLBACK_DEVICE_QUESTION_LABELS: QuestionLabels = {
  replacementThroughClaim: "Is this a replacement device you got through a claim?",
  newDeviceAlreadyActivated: "Is your new device already activated?",
  oldDeviceAccess: "Do you still have access to your old device?",
  oldDeviceFunctional: "Is your old device still functional?",
  newDeviceIsNewiPhoneVersion: "Is your new device an iPhone 14 or newer?",
  newDeviceIsiPhone14: "Is your new device an iPhone 14 or newer?",
}

export const FALLBACK_DEVICE_QUESTION_LABELS_ATT = {
  "replacementThroughClaim": "Is this a replacement device you got through a claim?",
  "newDeviceAlreadyActivated": "Is your replacement device already activated?",
  "oldDeviceAccess": "Do you still have access to your original device?",
  "oldDeviceFunctional": "Is your original device still functional?",
  "newDeviceIsiPhone14": "Is your new device an iPhone 14?",
  newDeviceIsNewiPhoneVersion: "Is your new device an iPhone 14?"
}
